import { Component, Inject } from '@angular/core';
import { APP_CONFIG } from '@mnz-core/injectors/app-configuration';
import { IAppConfiguration } from '@mnz-core/models/app-configuration';

@Component({
  selector: 'mnz-customer-requirements',
  templateUrl: 'customer-requirements.component.html',
})
export class CustomerRequirementsComponent {
  constructor(@Inject(APP_CONFIG) private readonly _config: IAppConfiguration) {}

  openTermsAndConditions(): void {
    const { terms_and_conditions } = this._config.footerUrls;
    location.assign(terms_and_conditions);
  }

  openPrivacy(): void {
    const { privacy } = this._config.footerUrls;
    location.assign(privacy);
  }

  openCustomerService(): void {
    const { customer_service } = this._config.footerUrls;
    location.assign(customer_service);
  }
}
